import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { CompanyHeader } from './components/CompanyHeader'

const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Company Details',
    path: '/company_overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const CompanyOverviewPage: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <CompanyHeader />
          </>
        }
      >
        <Route
          path='details/:id'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
              <CompanyHeader />
            </>
          }
        />
        <Route
          path='sites/:id'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Sites</PageTitle>
              <CompanyHeader />
            </>
          }
        />
        <Route
          path='meters/:id'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Meters</PageTitle>
              <CompanyHeader />
            </>
          }
        />
        <Route
          path='notes/:id'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Notes</PageTitle>
              <CompanyHeader />
            </>
          }
        />
        <Route
          path='tasks/:id'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Tasks</PageTitle>
              <CompanyHeader />
            </>
          }
        />
        <Route
          path='task_comments/:id'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Task Comments</PageTitle>
              <CompanyHeader />
            </>
          }
        />
        <Route index element={<Navigate to='/company_overview/details' />} />
      </Route>
    </Routes>
  )
}

export default CompanyOverviewPage
